/**
 * Builds the TinyMCE config for dark mode: dark skin for the editor chrome and dark content CSS
 * for the editing iframe. The iframe document is transparent so the editor shows the surface behind
 * it, like the app's outlined inputs.
 * @param {Object} [config={}] - TinyMCE init config provided by the caller
 * @param {Object} theme - Resolved MUI theme with concrete palette colors
 * @returns {Object} TinyMCE init config for dark mode
 */
export const getDarkEditorConfig = (config = {}, theme) => {
  const { text } = theme.palette;
  const darkContentStyle = `html { color-scheme: dark; background-color: transparent; } body { background-color: transparent; color: ${text.primary}; }`;

  return {
    ...config,
    skin: 'oxide-dark',
    content_css: 'dark',
    content_style: [config.content_style, darkContentStyle].filter(Boolean).join(' ')
  };
};
